import React from 'react';
import PropTypes from 'prop-types';
import getSourceSetValues from '@/helpers/getSourceSetValues';
import { resizeImageSourceMax } from '@/helpers/resizeImageSource';

export const ImageHero = ({ backgroundImageUrl, altText }) => {
  if (!backgroundImageUrl) {
    return null;
  }

  return (
    <img
      srcSet={getSourceSetValues(backgroundImageUrl).join(', ')}
      src={resizeImageSourceMax(backgroundImageUrl)}
      sizes="((orientation: portrait) and (max-width: 480px) 480px )"
      alt={altText}
    />
  );
};

ImageHero.defaultProps = {
  backgroundImageUrl: null,
  altText: '',
};

ImageHero.propTypes = {
  backgroundImageUrl: PropTypes.string,
  altText: PropTypes.string,
};

export default ImageHero;
